import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/notification-templates', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/notification-templates/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/notification-templates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/notification-templates/${data.not_template_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const notificationParams = id => {
  return httpClient
    .get(`/api/notification-templates/parameters/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const notificationTypes = (Options = {}) => {
  return httpClient
    .get('/api/notification-templates/types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const imageContent = data => {
  return httpClient
    .post('/api/notification-templates/image-contents', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  notificationParams,
  notificationTypes,
  imageContent
}
